import { useMemo } from 'react'
import moment from 'moment-timezone'
import { useTheme } from '@mui/material/styles'

import {Box } from '@mui/material'

import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table'

import StyledPaper from '../paper.jsx'
import { createTableStyles } from '../table-styles'

const RequestHistoryTable = ({ threads, loading, selectThread}) => {

  const theme = useTheme()
  const tableStyles = useMemo(() => createTableStyles(theme), [theme])

  const columns = useMemo(() => [
    {
      id: 'created',
      accessorFn: (originalRow) => moment(originalRow.created, "YYYYMMDDHHmmSS"),
      header: 'Created',
      filterVariant: 'date-range',
      sortingFn: 'datetime',
      size: 200,
      Cell: ({ cell }) => cell.getValue().format("DD MMM YYYY HH:mm")
    },
    {
      accessorKey: 'subject',
      header: 'Subject',
      filterVariant: 'autocomplete',
      size: 800,
    },
    {
      accessorKey: 'status',
      header: 'Status',
      filterVariant: 'autocomplete',
      size: 800,
    },    
  ])

  const table = useMaterialReactTable({
    columns,
    data : threads,
    state : {
      isLoading : loading,
    },
    initialState: { showColumnFilters: false },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableRowActions: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: "none",
    getRowId: (originalRow) => originalRow.thread_id,
    ...tableStyles, // Overrides  muiTableBodyRowProps, so ensure it is placed before muiTableBodyRowProps

    muiTableBodyRowProps: ({ row }) => {
      const { status, thread_id: threadId } = row.original ?? {}
      const statusStyles =
        status === 'replied'
          ? { fontWeight: 700 }
          : status === 'closed'
            ? { color: 'text.disabled' }
            : null

      return {
        onClick: () => {
          if (threadId) {
            selectThread(threadId)
          }
        },
        sx: {
          cursor: 'pointer',
          ...(statusStyles ? { '& .MuiTableCell-root': statusStyles } : {}),
        },
      }
    },
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <MRT_ToggleGlobalFilterButton table={table} />
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
      </Box>
    )
  })

  return (
  <StyledPaper sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }} height="100vh">
    <MaterialReactTable table={table} />
  </StyledPaper>
  )
}

export default RequestHistoryTable
